import {Input, DatePicker, Rate, Checkbox} from 'antd';
import FileUploadField from '../FileUploadField';
import SelectField from '../SelectField';
import RadioField from '../RadioField';
import moment from 'moment-timezone';

const CaseComponent = ({
	type,
	inputProps,
	datePickerProps,
	rangePickerProps,
	selectProps,
	uploadProps,
	rateProps,
	radioProps,
	checkboxProps,
	textAreaProps,
	checkboxGroupProps,
	...rest
}: any) => {
	switch (type) {
		case 'text':
			return <Input {...rest} {...inputProps} />;
		case 'textArea':
			return <Input.TextArea {...rest} {...textAreaProps} />;
		case 'date':
			return (
				<DatePicker
					placeholder={datePickerProps?.format === 'YYYY' ? 'Ընտրեք տարի' : 'Ընտրեք ամսաթիվ'}
					format="DD-MM-YYYY"
					{...rest}
					{...datePickerProps}
					value={
						rest.value &&
						(datePickerProps?.format === 'YYYY'
							? moment(new Date().setFullYear(rest.value)).tz('Asia/Yerevan')
							: moment(rest.value).tz('Asia/Yerevan'))
					}
					style={{width: '100%'}}
				/>
			);
		case 'dateRange':
			return <DatePicker.RangePicker {...rest} {...rangePickerProps} style={{width: '100%'}} />;
		case 'select':
			return <SelectField {...rest} {...selectProps} />;
		case 'file':
			return <FileUploadField {...rest} {...uploadProps} />;
		case 'rate':
			return <Rate {...rest} {...rateProps} character={({index}: {index: number}) => index + 1} />;
		case 'radio':
			return <RadioField {...rest} {...radioProps} />;
		case 'checkbox':
			return <Checkbox {...rest} {...checkboxProps} />;
		case 'checkboxGroup':
			return <Checkbox.Group {...rest} {...checkboxGroupProps} />;
		default:
			return null;
	}
};

export default CaseComponent;
